<section class="row p-2 pt-1" *ngIf="setting.options.length > 1">
  <mat-form-field *ngIf="singleColumn ? false : showDragDropSection()" class="col-md-auto col-xs-12">
    <input
      matInput
      placeholder="Search"
      [(ngModel)]="searchText"
      (ngModelChange)="filterList()"
      (keydown.enter)="selectOption()"
      [acsFocus]="jumpFocus === 'searchText'"
      autocomplete="off"
    />
    <button mat-icon-button matSuffix (click)="clearInput()" color="warn">
      <mat-icon class="fa fa-close"></mat-icon>
    </button>
  </mat-form-field>

  <span class="align-self-center col col-xs-12">
    <button mat-raised-button class="md-button m-2" *ngIf="setting.showAllOption" (click)="setting.selectAll()">All</button>
    <button mat-raised-button class="md-button m-2" *ngIf="setting.showNoneOption" (click)="setting.unselectAll()">None</button>
    <button mat-raised-button class="md-button m-2" *ngIf="showAddButton" (click)="addOption()">Add</button>
    <span *ngFor="let group of setting.optionGroupings; trackBy: getIdentifierForIterableItem">
      <button
        mat-raised-button
        class="md-button m-2"
        aria-label=""
        *ngFor="let option of group.options; trackBy: getIdentifierForIterableItem"
        (click)="setting.selectGroup(group.id, option.id)"
      >
        {{ option.name }}
      </button>
    </span>
  </span>
</section>

<mat-list role="list" class="d-flex row" *ngIf="singleColumn ? false : !showDragDropSection()">
  <mat-list-item
    class="col-4"
    role="listitem"
    *ngFor="let option of setting.options; trackBy: getIdentifierForIterableItem"
  >
    <mat-checkbox color="primary" [(ngModel)]="option.selected"
      ><p>{{ option.name }}</p></mat-checkbox
    >
  </mat-list-item>
</mat-list>

<div *ngIf="singleColumn ? false : showDragDropSection()" class="row mb-3">
    <div class="example-container col">
      <h4 class="sub-header">Available</h4>

      <div
        cdkDropList
        #availableList="cdkDropList"
        [cdkDropListData]="available"
        [cdkDropListConnectedTo]="[selectedList]"
        class="example-list"
        style="max-height: 400px; overflow: auto;"
        (cdkDropListDropped)="drop($event)"
      >
        <div
          class="example-box"
          *ngFor="let item of available; trackBy: getIdentifierForIterableItem"
          cdkDrag
          [cdkDragDisabled]="selected.length === 12"
        >
          <mat-checkbox
            [(ngModel)]="item.selected"
            [disabled]="selected.length === 12"
            (ngModelChange)="filterList()"
            color="primary"
            >{{ item.name }}</mat-checkbox
          >
        </div>
      </div>
    </div>

    <div class="example-container col">
      <h4 class="sub-header">Selected</h4>

      <div
        cdkDropList
        #selectedList="cdkDropList"
        [cdkDropListData]="selected"
        [cdkDropListConnectedTo]="[availableList]"
        class="example-list"
        style="max-height: 400px; overflow: auto;"
        (cdkDropListDropped)="drop($event)"
      >
        <div
          class="example-box"
          *ngFor="let item of selected; trackBy: getIdentifierForIterableItem"
          cdkDrag
          [cdkDragDisabled]="selected.length === 1 && !setting.allowEmpty">
          <mat-checkbox
            [(ngModel)]="item.selected"
            [disabled]="selected.length === 1 && !setting.allowEmpty"
            color="primary"
            (ngModelChange)="filterList()"
            >{{ item.name }}</mat-checkbox
          >
        </div>
      </div>
    </div>
</div>


<div *ngIf="singleColumn" class="row mb-3 mt-2">
    <div class="example-container col">
      <div
        class="example-list"
        style="max-height: 400px; overflow: auto;">
        <div
          class="example-box"
          style="cursor: default;"
          *ngFor="let item of setting.options; trackBy: getIdentifierForIterableItem">
          <mat-checkbox
            [(ngModel)]="item.selected"
            color="primary">{{ item.name }}</mat-checkbox
          >
        </div>
      </div>
    </div>
</div>
